import { createReducer, on, Action } from '@ngrx/store';

import * as UberallActions from './../actions/uberall/uberall.actions';
import { IAnalyticsResponse } from './../../../api/models/uberal.models';

export interface UberallState {
  accessToken: string;
  locationId: string;
  establishmentId: string;
  analyticsData: IAnalyticsResponse;
  fetchingAnalytics: boolean;
  fetchingAnalyticsFailed: boolean;
}

const initialSate: UberallState = {
  accessToken: null,
  locationId: null,
  establishmentId: null,
  analyticsData: null,
  fetchingAnalytics: false,
  fetchingAnalyticsFailed: false,
};

export const uberallReducer = createReducer(
  initialSate,
  on(UberallActions.setUberallData, (state, payload) => {
    const { accessToken, locationId } = payload;
    return {
      ...state,
      accessToken,
      locationId,
    };
  }),
  on(UberallActions.getAnalyticsAttempt, state => ({ ...state, fetchingAnalytics: true })),
  on(UberallActions.getAnalyticsSuccess, (state, payload) => ({
    ...state,
    fetchingAnalytics: false,
    fetchingAnalyticsFailed: false,
    analyticsData: payload,
  })),
  on(UberallActions.getAnalyticsFailure, state => ({ ...state, fetchingAnalytics: false, fetchingAnalyticsFailed: true }))
);

export function reducer(state: UberallState | undefined, action: Action) {
  return uberallReducer(state, action);
}
